var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaMissouriMoMillionsDoublePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 419.87 196.93",
    style: {
      backgroundColor: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 132.42,
    y1: 133.86,
    x2: 132.42,
    y2: 133.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d99a2e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "g",
    x1: 119.56,
    y1: 190.06,
    x2: 119.56,
    y2: 190.11,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "h",
    x1: 137.76,
    y1: 140.31,
    x2: 137.76,
    y2: 195.29,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "i",
    x1: 146.67,
    y1: 119.68,
    x2: 146.67,
    y2: 139.05,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "j",
    x1: 165.65,
    y1: 121.37,
    x2: 165.65,
    y2: 195.29,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "k",
    x1: 145.24,
    y1: 190.04,
    x2: 145.24,
    y2: 190.11,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "l",
    x1: 257.14,
    y1: 145.48,
    x2: 257.14,
    y2: 196.89,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "m",
    x1: 251.26,
    y1: 152.16,
    x2: 251.26,
    y2: 178.32,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "n",
    x1: 313.69,
    y1: 190.08,
    x2: 313.69,
    y2: 190.11,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "o",
    x1: 279.21,
    y1: 190.06,
    x2: 279.21,
    y2: 190.11,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "p",
    x1: 309.51,
    y1: 140.31,
    x2: 309.51,
    y2: 148.45,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "q",
    x1: 330.17,
    y1: 142.59,
    x2: 330.17,
    y2: 195.29,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "r",
    x1: 299.73,
    y1: 154.17,
    x2: 299.73,
    y2: 195.29,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "s",
    x1: 370.93,
    y1: 149.58,
    x2: 370.93,
    y2: 155.73,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "t",
    x1: 360.52,
    y1: 165.31,
    x2: 360.52,
    y2: 177.2,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "u",
    x1: 388.28,
    y1: 144.83,
    x2: 388.28,
    y2: 159.7,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "v",
    x1: 361.02,
    y1: 174.86,
    x2: 361.02,
    y2: 180.73,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "w",
    x1: 371.15,
    y1: 165.5,
    x2: 371.15,
    y2: 196.93,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "x",
    x1: 189.64,
    y1: 121.37,
    x2: 189.64,
    y2: 195.29,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "y",
    x1: 169.22,
    y1: 190.04,
    x2: 169.22,
    y2: 190.11,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "z",
    x1: 205.82,
    x2: 205.82,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "A",
    x1: 192.95,
    y1: 190.06,
    x2: 192.95,
    y2: 190.11,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "B",
    x1: 220.07,
    y1: 119.68,
    x2: 220.07,
    y2: 139.05,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "C",
    x1: 211.16,
    y1: 140.31,
    x2: 211.16,
    y2: 195.29,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "D",
    x1: 30.81,
    y1: 190.04,
    x2: 30.81,
    y2: 190.11,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "E",
    x1: 77.58,
    y1: 121.37,
    x2: 77.58,
    y2: 164.05,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "F",
    x1: 89.62,
    y1: 190.07,
    x2: 89.62,
    y2: 190.11,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "G",
    x1: 110.34,
    y1: 121.37,
    x2: 110.34,
    y2: 195.29,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "H",
    x1: 81.68,
    y1: 146.2,
    x2: 81.68,
    y2: 195.29,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "I",
    x1: 46.15,
    y1: 146.35,
    x2: 46.15,
    y2: 195.29,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 137.68,
    y1: 119.68,
    x2: 137.68,
    y2: 190.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2060aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023473"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "J",
    x1: 163.09,
    y1: 121.37,
    x2: 163.09,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "K",
    x1: 251.54,
    y1: 138.78,
    x2: 251.54,
    y2: 191.7,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "L",
    x1: 310.36,
    y1: 138.88,
    x2: 310.36,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "M",
    x1: 367.3,
    y1: 138.88,
    x2: 367.3,
    y2: 191.75,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "N",
    x1: 187.07,
    y1: 121.37,
    x2: 187.07,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "O",
    x1: 211.07,
    x2: 211.07,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "P",
    x1: 78.37,
    y1: 121.37,
    x2: 78.37,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 168.52,
    y1: 35.74,
    x2: 168.52,
    y2: 112.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec3b33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc2423"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Q",
    x1: 74.82,
    y1: 40.17,
    x2: 74.82,
    y2: 84.85,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "R",
    x1: 52.07,
    y1: 66.24,
    x2: 52.07,
    y2: 117.2,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "S",
    x1: 86.79,
    y1: 66.26,
    x2: 86.79,
    y2: 117.2,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "T",
    x1: 113.28,
    y1: 40.17,
    x2: 113.28,
    y2: 117.2,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "U",
    x1: 80.16,
    y1: 40.17,
    x2: 80.16,
    y2: 112.44,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "V",
    y1: 50.3,
    y2: 98.13,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "W",
    x1: 168.35,
    y1: 64.62,
    x2: 168.35,
    y2: 83.8,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "X",
    x1: 178.58,
    y1: 48.85,
    x2: 178.58,
    y2: 117.16,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Y",
    x1: 391.57,
    y1: 134.28,
    x2: 391.57,
    y2: 139.34,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Z",
    x1: 396.98,
    y1: 134.28,
    x2: 396.98,
    y2: 139.34,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 16.28,
    cy: 76.22,
    fx: 5.78,
    fy: 63.77,
    r: 16.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006fa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#006ba7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#005fa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#004ca7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003ca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 27.45,
    cy: 154.07,
    fx: 17.85,
    fy: 140.92,
    r: 16.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed3f34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#e93d32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#dd3a2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c93429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ae2b20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d261b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "aa",
    cx: 146.67,
    cy: 16.28,
    fx: 135.92,
    fy: 4.05,
    r: 16.28,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "ab",
    cx: 297.33,
    cy: 61.56,
    fx: 285.65,
    fy: 50.21,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 91.1,
    cy: 32.57,
    fx: 81.5,
    fy: 19.42,
    r: 16.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#efb425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#dca226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d19827"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "ac",
    cx: 215.53,
    cy: 32.92,
    fx: 205.92,
    fy: 19.77,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "ad",
    cx: 298.98,
    cy: 114.59,
    fx: 289.37,
    fy: 101.44,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "ae",
    cx: 244.89,
    cy: 93.28,
    fx: 235.28,
    fy: 80.13,
    r: 16.28,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "af",
    cx: 357.8,
    cy: 126.83,
    fx: 348.19,
    fy: 113.68,
    xlinkHref: "#f"
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#a)",
      opacity: 0.5
    },
    d: "M132.43 133.86h-.01v.01l.01-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#g)",
      opacity: 0.5
    },
    d: "m119.57 190.06-.02.04.01.01.01-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#h)"
    },
    d: "M150.78 140.34h.07l-11.5 49.79h-19.78l5.08 5.16h19.81l11.49-49.79-5.1-5.19-.07.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#i)"
    },
    d: "m155.8 119.68-.07.02h.07l-3.42 14.19h-19.94l5.08 5.16h19.97l3.42-14.19-5.11-5.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#j)"
    },
    d: "m180.95 121.37-.07.03h.07l-15.87 68.73h-19.83l5.08 5.16h19.86l15.86-68.73-5.1-5.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#k)",
      opacity: 0.5
    },
    d: "m145.25 190.04-.02.06v.01l.02-.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M283.16 152.79c-1.59-2.44-3.89-5.06-6.76-7.31.6.67 1.16 1.38 1.66 2.14 3.07 4.74 3.81 10.57 2.21 17.5-1.8 7.79-5.85 14.17-12.17 19.14-6.31 4.97-14.03 7.46-23.15 7.46-7.11 0-13.17-2.12-16.86-4.94 1.25 1.47 2.53 2.78 3.66 3.91 3.42 3.42 10.17 6.2 18.31 6.2 9.12 0 16.84-2.49 23.15-7.46 6.31-4.97 10.37-11.35 12.17-19.14 1.6-6.93.86-12.76-2.21-17.5Z",
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.48 178.32c-.41-2.02-.29-4.61.38-7.8.93-4.45 2.46-7.76 4.58-9.94 2.12-2.18 4.47-3.27 7.03-3.27.32 0 .62.02.92.06-.13-.79-.32-1.49-.61-2-1.19-2.15-3-3.22-5.42-3.22-2.56 0-4.91 1.09-7.03 3.27-2.13 2.18-3.65 5.49-4.58 9.94-.94 4.51-.81 7.85.39 10.01.93 1.67 2.8 2.64 4.33 2.95Z",
    style: {
      fill: "url(#m)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#n)",
      opacity: 0.5
    },
    d: "M313.69 190.1v.01l.01-.03-.01.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#o)",
      opacity: 0.5
    },
    d: "m279.22 190.06-.02.04.01.01.01-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.75 140.34-1.87 8.11c1.78-1.73 3.55-3.33 5.27-4.68l-3.4-3.45-.06.03h.06Z",
    style: {
      fill: "url(#p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.08 149.09c-1.34-1.86-3.57-4.58-6.25-6.5.41.42.8.86 1.15 1.33 2.26 3.14 3.35 7.99 1.84 14.56l-7.31 31.65h-19.79l5.08 5.16h19.82l7.31-31.65c1.52-6.56.42-11.42-1.84-14.56Z",
    style: {
      fill: "url(#q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.15 159.33h.09c-.15-1.38-.61-2.46-1.11-3.22-.86-1.3-1.99-1.95-4.08-1.95-2.31 0-4.39.88-6.23 2.63-1.84 1.75-3.29 4.89-4.33 9.42l-5.52 23.91h-19.74l5.08 5.16h19.76l5.52-23.91c1.05-4.53 2.49-7.67 4.33-9.42 1.84-1.75 3.92-2.63 6.23-2.63Z",
    style: {
      fill: "url(#r)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M374.15 153.23c.66.22 2.5 1.15 2.51 1.16-.1-1.58-.39-2.57-.88-3.25-.92-1.27-3.52-1.54-4.73-1.55-.91 0-2.79.18-3.6.6-.78.4-1.87 1.69-2.12 2.79-.28 1.22-.27 2.31 1.24 2.76 0 0 .81-1.64 2.07-2.25 2.04-.99 4.2-.69 5.51-.26Z",
    style: {
      fill: "url(#s)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.15 168.06c-.19-.08-.37-.17-.56-.27.03.07-2.76-2.55-2.73-2.48 1.22 2.34 4.99 6.69 8.39 7.91 2.34.84 4.55 2.02 10.91 3.18 1.44.26 2.66.54 3.69.81.1-.2.19-.4.24-.6.32-1.37-.16-2.43-1.42-3.18-.91-.53-3.36-1.4-7.61-2.18-6.36-1.15-8.55-2.19-10.91-3.18Z",
    style: {
      fill: "url(#t)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.99 149.95c-.94-1.23-3.02-3.46-5.08-5.13 1.43 1.92 2.12 5.6 1.77 9.71H376.7l5.08 5.16h18c.35-4.13-.34-7.84-1.79-9.74Z",
    style: {
      fill: "url(#u)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.47 179.74c.89.56 2.08.86 3.19 1-.03-.22-.05-.44-.08-.68l-5.1-5.19-.1.02h.1c.26 2.25.36 3.81 1.99 4.85Z",
    style: {
      fill: "url(#v)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.93 165.5c.12.17.25.33.35.5 1.34 2.22 1.57 5.17.92 8.01-.66 2.87-1.83 5.62-4.19 8.33-2.36 2.72-5.6 4.88-9.7 6.49-4.11 1.61-9.46 2.93-15.89 2.93-8.45 0-14.55-1.31-17.77-3.82 1.26 1.46 2.76 2.96 4.42 4.57 2.99 2.9 9.36 4.41 18.46 4.41 6.44 0 11.79-1.33 15.89-2.93 4.11-1.61 7.34-3.77 9.7-6.49 2.36-2.72 3.53-5.46 4.19-8.33.66-2.84.42-5.79-.92-8.01-.93-1.54-3.21-3.91-5.45-5.67Z",
    style: {
      fill: "url(#w)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#x)"
    },
    d: "m204.93 121.37-.07.03h.07l-15.86 68.73h-19.84l5.08 5.16h19.86l15.87-68.73-5.11-5.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#y)",
      opacity: 0.5
    },
    d: "m169.23 190.04-.02.06v.01l.02-.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#z)",
      opacity: 0.5
    },
    d: "M205.82 133.86v.01-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#A)",
      opacity: 0.5
    },
    d: "m192.96 190.06-.01.04v.01l.01-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#B)"
    },
    d: "m229.2 119.68-.08.02h.08l-3.42 14.19h-19.94l5.08 5.16h19.96l3.42-14.19-5.1-5.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#C)"
    },
    d: "M224.17 140.34h.07l-11.49 49.79h-19.78l5.08 5.16h19.8l11.5-49.79-5.11-5.19-.07.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#D)",
      opacity: 0.5
    },
    d: "m30.82 190.04-.02.06.01.01.01-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#E)"
    },
    d: "m74.3 121.4 2.3 42.65 4.37-8.49-1.57-29-5.1-5.19-.11.03h.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#F)",
      opacity: 0.5
    },
    d: "m89.61 190.1.01.01.01-.04-.02.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#G)"
    },
    d: "m125.94 121.37-.11.03h.11l-16.2 68.73h-20.1l5.08 5.16h20.12l16.21-68.73-5.11-5.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#H)"
    },
    d: "m96.4 161.38 4.72-15.18-22.82 43.93H62.24l5.08 5.16H83.4l9.16-17.62 3.84-16.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#I)"
    },
    d: "m60.26 146.35-2.51 15.7-6.35 28.08H30.83l5.08 5.16h20.6l4.96-21.93-1.21-27.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.84 119.68h19.96l-3.42 14.19h-19.96l3.42-14.19Zm-4.8 20.63h19.8l-11.49 49.79h-19.8l11.49-49.79Z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.09 121.37h19.86l-15.87 68.73h-19.86l15.87-68.73Z",
    style: {
      fill: "url(#J)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.84 165.36c1.78-7.72 7.1-15.58 11.42-19.07 4.68-3.78 13.99-7.51 22.85-7.51 10.14 0 17.12 2.94 20.94 8.82 3.07 4.74 3.81 10.57 2.21 17.5-1.8 7.79-5.85 14.17-12.17 19.14-6.31 4.97-14.03 7.46-23.15 7.46-8.14 0-14.89-2.78-18.31-6.2-4.27-4.27-5.72-11.85-3.8-20.14Zm19.91-.02c-.94 4.51-.81 7.85.39 10.01 1.2 2.16 3.98 3.15 5.56 3.06 1.87-.11 5.52-1.86 6.74-3.28 1.79-2.09 4.08-7.28 4.67-9.96.53-2.4.86-7.67-.33-9.81-1.19-2.15-3-3.22-5.42-3.22-2.56 0-4.91 1.09-7.03 3.27-2.13 2.18-3.65 5.49-4.58 9.94Z",
    style: {
      fill: "url(#K)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.7 140.31h18.05l-1.87 8.11c3.42-3.31 6.78-6.2 9.83-7.62s7.05-1.92 10.96-1.92c5.28 0 9.05 1.88 11.31 5.02 2.26 3.14 3.35 7.99 1.84 14.56l-7.31 31.65h-19.82l6.32-27.38c.72-3.12-.03-5.34-.88-6.63-.86-1.3-1.99-1.95-4.08-1.95-2.31 0-4.39.88-6.23 2.63-1.84 1.75-3.29 4.89-4.33 9.42l-5.52 23.91h-19.76l11.49-49.79Z",
    style: {
      fill: "url(#L)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.89 174.77 18.58.09c.26 2.25.36 3.81 1.99 4.85s4.04 1.17 5.42 1.06c.94-.08 2.92-.55 3.57-1.23s2.06-1.82 2.34-3.04c.32-1.37-.16-2.43-1.42-3.18-.91-.53-3.36-1.4-7.61-2.18-6.36-1.15-8.55-2.19-10.91-3.18-2.35-.98-4.35-2.88-5.58-5.22-1.23-2.34-.81-5-.12-8 .76-3.28 2.36-6.1 4.82-8.48 2.45-2.37 5.22-4.46 8.83-5.63 3.61-1.17 8.23-1.76 13.86-1.76 5.94 0 10.49.76 13.11 1.67 2.62.91 4.65 2.31 6.11 4.22 1.45 1.91 2.14 5.62 1.79 9.74h-18c-.1-1.59-.38-2.59-.88-3.28-.92-1.27-3.52-1.54-4.73-1.55-.91 0-2.79.18-3.6.6s-1.87 1.69-2.12 2.79c-.28 1.22.13 2.14 1.24 2.76 1.11.62 1.97 1.12 6.01 1.82 6.2 1.08 9.12 1.87 11.92 3.15 2.8 1.28 5.43 2.95 6.78 5.19s1.57 5.17.92 8.01-1.83 5.62-4.19 8.33c-2.36 2.72-5.6 4.88-9.7 6.49-4.11 1.61-9.46 2.93-15.89 2.93-9.1 0-15.47-1.51-18.46-4.41-4.87-4.73-4.07-7.78-4.06-12.56Z",
    style: {
      fill: "url(#M)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.08 121.37h19.86l-15.87 68.73h-19.86l15.87-68.73Z",
    style: {
      fill: "url(#N)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.23 119.68h19.96l-3.42 14.19h-19.96l3.42-14.19Zm-4.79 20.63h19.8l-11.49 49.79h-19.8l11.49-49.79Z",
    style: {
      fill: "url(#O)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 121.37h27.29l2.31 42.66 21.93-42.66h27.41l-16.2 68.73H89.61l6.79-28.74 4.72-15.19L78.3 190.1H62.22l-1.96-43.78-2.51 15.71-6.35 28.07H30.8L47 121.37Z",
    style: {
      fill: "url(#P)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M139.45 190.13h-19.8l.42-1.83-.52 1.8 2.25 2.29h19.8l11.49-49.79-2.16-2.2-11.48 49.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      opacity: 0.5
    },
    d: "m155.83 119.7-.03-.02-.19.02h.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "m155.89 119.76-3.41 14.13h-19.96l.11-.47-.21.44 2.24 2.29h19.97l3.42-14.18-2.16-2.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      opacity: 0.5
    },
    d: "M150.66 140.34h.21l-.02-.03-.19.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      opacity: 0.5
    },
    d: "m180.97 121.4-.02-.03-.19.03h.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "m181.04 121.46-15.86 68.67h-19.85l.58-2.54-.68 2.51 2.24 2.29h19.86l15.87-68.73-2.16-2.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245.28 177.41c-1.1-2.16-1.2-5.42-.28-9.79.93-4.45 2.46-7.76 4.58-9.94 2.12-2.18 4.47-3.27 7.03-3.27 1.22 0 2.28.27 3.18.81-1.19-2.05-2.97-3.08-5.33-3.08-2.56 0-4.91 1.09-7.03 3.27-2.13 2.18-3.65 5.49-4.58 9.94-.94 4.51-.81 7.85.39 10.01.48.87 1.23 1.54 2.04 2.04Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.3 149.89c-.99-1.53-2.21-2.95-3.63-4.21.54.61 1.03 1.26 1.48 1.95 3.07 4.74 3.81 10.57 2.21 17.5-1.8 7.79-5.85 14.17-12.17 19.14-6.31 4.97-14.03 7.46-23.15 7.46-7.56 0-13.93-2.4-17.53-5.49.44.56.9 1.08 1.37 1.55 3.42 3.42 10.17 6.2 18.31 6.2 9.12 0 16.84-2.49 23.15-7.46 6.31-4.97 10.37-11.35 12.17-19.14 1.6-6.93.86-12.76-2.21-17.5Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      opacity: 0.5
    },
    d: "m308.77 140.34-.02-.03-.18.03h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.97 148.45c1.14-1.1 2.27-2.15 3.39-3.12l.63-2.72-2.16-2.2-1.86 8.05Zm34.25-2.26c-.69-.95-1.56-1.92-2.6-2.81.15.18.31.35.45.55 2.26 3.14 3.35 7.99 1.84 14.56l-7.31 31.65h-19.82l.23-.97-.32.95 2.24 2.29h19.82l7.31-31.65c1.52-6.56.42-11.42-1.84-14.56Zm-21.58 10.66c-.13-.27-.27-.52-.41-.74-.86-1.3-1.99-1.95-4.08-1.95-2.31 0-4.39.88-6.23 2.63-1.84 1.75-3.29 4.89-4.33 9.42l-5.52 23.91h-19.76l.42-1.82-.52 1.8 2.24 2.29h19.76l5.52-23.91c1.05-4.53 2.49-7.67 4.33-9.42 1.84-1.75 3.92-2.63 6.23-2.63.97 0 1.72.15 2.35.42Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M351.96 167.98c-1.33-.55-2.53-1.41-3.56-2.46 1.31 2.08 3.56 3.82 5.7 4.72 2.35.98 4.55 2.02 10.91 3.18 3.48.64 5.73 1.33 6.94 1.85-.14-.79-.62-1.43-1.47-1.94-.91-.53-3.36-1.4-7.61-2.18-6.36-1.15-8.55-2.19-10.91-3.18Zm8.61 11.76c.2.13.43.24.66.35-.28-.81-.37-1.78-.5-2.93l-2.14-2.18c.25 2.2.38 3.74 1.98 4.76Zm34.56-32.68c-.44-.57-1.11-1.21-1.88-1.84 1.26 2 1.85 5.47 1.52 9.32h-18c-.1-1.59-.38-2.59-.88-3.28-.92-1.27-3.52-1.54-4.73-1.55-.91 0-2.79.18-3.6.6-.78.4-1.87 1.69-2.12 2.79-.28 1.22.13 2.14 1.24 2.76.28.16.54.3.84.45-.03-.29-.01-.61.07-.95.25-1.09.51-1.84 2.12-2.79.79-.46 2.33-.92 3.6-.6 2.35.6 3.37 2.55 3.37 2.55l2.24 2.29h18c.35-4.13-.34-7.84-1.79-9.74Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "m358.5 174.89-.02-.03-.14.03h.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.17 165.7c.07.1.15.2.21.3 1.34 2.22 1.57 5.17.92 8.01-.66 2.87-1.83 5.62-4.19 8.33-2.36 2.72-5.6 4.88-9.7 6.49-4.11 1.61-9.46 2.93-15.89 2.93-9.1 0-15.47-1.51-18.46-4.41-.27-.26-.52-.52-.75-.77.77.91 1.72 1.89 2.9 3.03 2.99 2.9 9.36 4.41 18.46 4.41 6.44 0 11.79-1.33 15.89-2.93 4.11-1.61 7.34-3.77 9.7-6.49 2.36-2.72 3.53-5.46 4.19-8.33.66-2.84.42-5.79-.92-8.01-.58-.96-1.4-1.81-2.36-2.57Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      opacity: 0.5
    },
    d: "m204.96 121.4-.03-.03-.19.03h.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "m205.02 121.46-15.85 68.67h-19.86l.59-2.54-.69 2.51 2.24 2.29h19.86l15.87-68.73-2.16-2.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M212.85 190.13h-19.8l.42-1.83-.52 1.8 2.24 2.29h19.8l11.5-49.79-2.16-2.2-11.48 49.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      opacity: 0.5
    },
    d: "m229.22 119.7-.02-.02-.2.02h.22zm-5.17 20.64h.22l-.03-.03-.19.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "m229.28 119.76-3.4 14.13h-19.97l.12-.47-.21.44 2.24 2.29h19.96l3.42-14.18-2.16-2.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "m76.7 164.05 1.83-3.56-1.99-36.83-2.14-2.18 2.3 42.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      opacity: 0.5
    },
    d: "m74.32 121.4-.02-.03-.28.03h.3zm51.65 0-.03-.03-.27.03h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "m96.5 161.38 4.72-15.18-22.83 43.93H62.32l-.09-1.93-.01 1.9 2.24 2.29h16.08l15.84-30.48.12-.53zm-36.14-15.03-2.51 15.7-6.35 28.08H30.9l.6-2.54-.7 2.51 2.25 2.29h20.6L60 164.32l.91-5.7-.55-12.27zm65.67-24.89-16.19 68.67H89.71l.27-1.15-.37 1.12 2.25 2.29h20.13l16.2-68.73-2.16-2.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 168.52,
    cy: 74.21,
    r: 38.47,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.52 35.74c-21.25 0-38.47 17.22-38.47 38.47s17.22 38.47 38.47 38.47 38.47-17.22 38.47-38.47-17.22-38.47-38.47-38.47Zm0 68.2c-16.42 0-29.73-13.31-29.73-29.73s13.31-29.73 29.73-29.73 29.73 13.31 29.73 29.73-13.31 29.73-29.73 29.73Z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#Q)"
    },
    d: "m82 78.49-9.42-33.56-4.94-4.76 12.55 44.68L82 78.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#R)"
    },
    d: "m65.03 87.74-6.08-21.5 1.35 19.77.04 26.43H38.85l4.94 4.76h21.49l-.04-26.44-.21-3.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#S)"
    },
    d: "m100.15 85.46 1.42-19.2-13.26 46.18h-16.3l4.94 4.76h16.3l6.9-24.05v-7.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#T)"
    },
    d: "M121.47 40.17v72.27h-21.32l4.95 4.76h21.31V44.93l-4.94-4.76z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.85 40.17h28.79l12.55 44.67 12.77-44.67h28.52v72.27h-21.32V85.46l1.41-19.2-13.25 46.18h-16.3l-13.06-46.2L60.3 86l.05 26.44h-21.5V40.17Z",
    style: {
      fill: "url(#U)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "m80.91 82.32-11.3-40.21-1.97-1.94 12.55 44.68.72-2.53zm-19.53-7.49-2.43-8.59 1.35 19.77.04 26.43H38.85l1.97 1.94h21.5l-.05-26.43-.89-13.12zm40.19-8.57-13.26 46.18h-16.3l1.98 1.94h16.3l10.4-36.25.88-11.87zm19.9-26.09v72.27h-21.32l1.98 1.94h21.32V42.11l-1.98-1.94z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.52 50.3c-13.21 0-23.92 10.71-23.92 23.92s10.71 23.92 23.92 23.92 23.92-10.71 23.92-23.92-10.71-23.92-23.92-23.92Zm0 39.44c-8.58 0-15.53-6.95-15.53-15.53s6.95-15.53 15.53-15.53 15.53 6.95 15.53 15.53-6.95 15.53-15.53 15.53Z",
    style: {
      fill: "url(#V)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.35,
    cy: 74.21,
    r: 9.59,
    style: {
      fill: "url(#W)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.3 48.89c5.92 6.77 9.52 15.62 9.52 25.32 0 21.25-17.22 38.47-38.47 38.47-10.61 0-20.21-4.29-27.17-11.24 7.05 8.05 17.4 13.15 28.95 13.15 21.25 0 38.47-17.22 38.47-38.47 0-10.64-4.32-20.27-11.3-27.23Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.15 48.85c7.07 6.98 11.45 16.66 11.45 27.38 0 21.25-17.22 38.47-38.47 38.47-9.21 0-17.66-3.24-24.29-8.64 6.95 6.86 16.49 11.1 27.02 11.1 21.25 0 38.47-17.22 38.47-38.47 0-12.04-5.53-22.78-14.18-29.83Z",
    style: {
      fill: "url(#X)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.28,
    cy: 76.22,
    r: 16.28,
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.45,
    cy: 154.07,
    r: 16.28,
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.06 139.34v-4.21h-1.5v-.86h4.02v.86h-1.5v4.21h-1.02Z",
    style: {
      fill: "url(#Y)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.1 139.34v-5.06h1.8l1.08 3.45 1.07-3.45h1.81v5.06h-1.12v-3.99l-1.18 3.99h-1.16l-1.18-3.99v3.99h-1.12Z",
    style: {
      fill: "url(#Z)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.67,
    cy: 16.28,
    r: 16.28,
    style: {
      fill: "url(#aa)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.33,
    cy: 61.56,
    r: 16.28,
    style: {
      fill: "url(#ab)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.1,
    cy: 32.57,
    r: 16.28,
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.53,
    cy: 32.92,
    r: 16.28,
    style: {
      fill: "url(#ac)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.98,
    cy: 114.59,
    r: 16.28,
    style: {
      fill: "url(#ad)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.89,
    cy: 93.28,
    r: 16.28,
    style: {
      fill: "url(#ae)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.8,
    cy: 126.83,
    r: 16.28,
    style: {
      fill: "url(#af)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaMissouriMoMillionsDoublePlay);
export default __webpack_public_path__ + "static/media/usa_missouri_mo_millions_double_play.ca13d6e87500d0aa99b7938ce7767921.svg";
export { ForwardRef as ReactComponent };